"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pxToRem = exports.getLineHeight = void 0;
var rootFontSize = 10; // 10px or 62.5%
/**
 * LineHeight converter
 * Takes expected lineHeight and fontSize
 * and returns a unitless value
 */
var getLineHeight = exports.getLineHeight = function getLineHeight(_ref) {
  var fontSize = _ref.fontSize,
    expectedLineHeight = _ref.expectedLineHeight;
  return expectedLineHeight / fontSize;
};
/**
 * Pixels to Rem converter
 * Takes pixels value without px,
 * Converts it into rem
 * and returns rem value including rem unit
 */
var pxToRem = exports.pxToRem = function pxToRem(px) {
  return "".concat(px / rootFontSize, "rem");
};